import * as React from "react";
import type { SvyPasswordProps } from "./SvyPassword.interface";
import { SvyInput } from "../SvyInput";
import { SvyIcon } from "@/indicators";

export const SvyPassword = React.forwardRef<HTMLInputElement, SvyPasswordProps>((props, ref) => {
    const [type, setType] = React.useState("password");
    const [icon, setIcon] = React.useState("eye-line");

    const handleToggle = (e: React.MouseEvent) => {
        e.preventDefault(); // Avoid selecting the input

        if (type === "password") {
            setType("text");
            setIcon("eye-off-line");
        } else {
            setType("password");
            setIcon("eye-line");
        }
    };

    const VisibilityButton = () => <SvyIcon icon={icon} onClick={handleToggle} />;

    return <SvyInput elementRight={<VisibilityButton />} type={type} ref={ref} {...props} />;
});

SvyPassword.displayName = "SvyPassword";
